import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { avatarAppConfig } from "./config";
const cogSvcRegion = avatarAppConfig.cogSvcRegion;
const cogSvcSubKey = avatarAppConfig.cogSvcSubKey;
const avatarBackgroundColor = "#00FF00FF";

export const createWebRTCConnection = (
  iceServerUrl,
  iceServerUsername,
  iceServerCredential
) => {
  var peerConnection = new RTCPeerConnection({
    iceServers: [
      {
        urls: [iceServerUrl],
        username: iceServerUsername,
        credential: iceServerCredential,
      },
    ],
  });

  return peerConnection;
};

export const createAvatarSynthesizer = (formData) => {
  console.log(formData, "all data");
  const voiceName = formData.voice;
  const avatarCharacter = formData.avatar;
  const avatarStyle = formData.style.trimStart();

  const speechSynthesisConfig = SpeechSDK.SpeechConfig.fromSubscription(
    cogSvcSubKey,
    cogSvcRegion
  );

  speechSynthesisConfig.speechSynthesisVoiceName = voiceName;

  const videoFormat = new SpeechSDK.AvatarVideoFormat();

  let videoCropTopLeftX = 600;
  let videoCropBottomRightX = 1320;
  videoFormat.setCropRange(
    new SpeechSDK.Coordinate(videoCropTopLeftX, 50),
    new SpeechSDK.Coordinate(videoCropBottomRightX, 1080)
  );

  const talkingAvatarCharacter = avatarCharacter;
  const talkingAvatarStyle = avatarStyle;

  const avatarConfig = new SpeechSDK.AvatarConfig(
    talkingAvatarCharacter,
    talkingAvatarStyle,
    videoFormat
  );
  avatarConfig.backgroundColor = avatarBackgroundColor;
  let avatarSynthesizer = new SpeechSDK.AvatarSynthesizer(
    speechSynthesisConfig,
    avatarConfig
  );

  avatarSynthesizer.avatarEventReceived = function (s, e) {
    var offsetMessage =
      ", offset from session start: " + e.offset / 10000 + "ms.";
    if (e.offset === 0) {
      offsetMessage = "";
    }
    console.log(
      "[" +
      new Date().toISOString() +
      "] Event received: " +
      e.description +
      offsetMessage
    );
  };
  return avatarSynthesizer;
};

export const saveToken = (token) => localStorage.setItem("authToken", token);
export const removeToken = () => localStorage.removeItem("authToken");
export const getToken = () => {
  console.log('sds')
  return localStorage.getItem("authToken");
}
export const saveUser = (user) => localStorage.setItem('user', JSON.stringify(user))
export const getUser = () => localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null; // Parse user data

export const isTokenExpired = (token) => {
  const expiry = JSON.parse(atob(token.split(".")[1])).exp;
  return Math.floor(new Date().getTime() / 1000) >= expiry;
};

// export const savemultiStepProcessId = (multiStepProcessId) => {
//   const user = JSON.parse(localStorage.getItem("user"));
//   user.multiStepProcessId = multiStepProcessId
//   localStorage.setItem("user", JSON.stringify(user));
//   return user;
// }

export const savemultiStepProcessId = (multiStepProcessId) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    user.multiStepProcessId = multiStepProcessId;
    localStorage.setItem("user", JSON.stringify(user));
  }
  return user;
}


export const debounce = (cb, delay) => {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    //run after delay
    timer = setTimeout(() => {
      cb(...args);
    }, delay);
  };
};
